import React from 'react';

function UsersSmsPage() {
    return <div>Users Sms Package Page</div>;
}

export default UsersSmsPage;
